import { WebApi } from '../../services/WebApi'

const state = () => ({
  caches: []
})

const getters = {
  findKioskSignInSetting: (state) => (siteId) => {
    return state.caches.find(c => c.key === siteId)
  }
}

const mutations = {
  setLoading (state, siteId) {
    const existing = state.caches.find(c => c.key === siteId)
    if (existing) {
      existing.loading = true
      existing.retry = false
    } else {
      state.caches.push({ key: siteId, value: null, loading: true, retry: false })
    }
  },
  setSetting (state, { siteId, setting }) {
    const existing = state.caches.find(c => c.key === siteId)
    if (existing) {
      existing.value = setting
      existing.loading = false
      existing.retry = false
    } else {
      state.caches.push({ key: siteId, value: setting, loading: false, retry: false })
    }
  },
  setRetry (state, siteId) {
    const existing = state.caches.find(c => c.key === siteId)
    if (existing) {
      existing.loading = false
      existing.retry = true
    }
  }
}

const actions = {
  fetchKioskSignInSetting ({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', siteId)
      WebApi.get('Kiosk/SignInSetting/' + siteId)
        .then(response => {
          commit('setSetting', { siteId, setting: response.data })
          resolve(response)
        })
        .catch(error => {
          commit('setRetry', siteId)
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
